import BATCHES_TABLE_CONFIG from '../../models/batchesTableConfig.js';

class UploadHistoryController {
  constructor() {
    this.name = 'uploadHistory';
    this.tab = BATCHES_TABLE_CONFIG;
    this.options = this.tab.options;
    this.rowOptions = {
      name: 'table-grid-accordion-row',
      drawerComponent: 'source-table',
      drawerClass: 'sourceTable__wrapper'
    };
  }
}

UploadHistoryController.$inject = [];

export default UploadHistoryController;



// WEBPACK FOOTER //
// ./app/components/uploadHistory/uploadHistory.controller.js